import React, { useEffect, createElement } from 'react';
import { ShieldCheck, Check, Star, ArrowRight, Lock, CreditCard } from 'lucide-react';
import { CountdownTimer } from './components/CountdownTimer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { FAQAccordion } from './components/FAQAccordion';
// Image URLs
const IMAGES = {
  main: 'https://cdn.magicpatterns.com/uploads/1stx75SQGPjFurESQtiD6H/1_Cover.png',
  bono1: 'https://cdn.magicpatterns.com/uploads/dDMpzRT3epxtncsfzTni8c/Bono_1.png',
  bono2: 'https://cdn.magicpatterns.com/uploads/vwynaZPANd8H63QLymjFa7/Bono_2.png',
  bono3: 'https://cdn.magicpatterns.com/uploads/cejnkx12ezdNQxnpxQA8mY/bono_3.png',
  bono4: 'https://cdn.magicpatterns.com/uploads/bAaycdcB7SYwup3AaxYFEs/Bono_4.png'
};
const CHECKOUT_URL = 'https://pay.hotmart.com/J104255735J?checkoutMode=10';
export function App() {
  // Meta Pixel Initialization
  useEffect(() => {
    // @ts-ignore
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      // Safe insertion: append to head instead of insertBefore
      const head = b.getElementsByTagName('head')[0];
      if (head) {
        head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // @ts-ignore
    if (window.fbq) {
      window.fbq('init', '3070568583125644');
      // @ts-ignore
      window.fbq('track', 'PageView');
    }
  }, []);
  const scrollToPurchase = () => {
    const element = document.getElementById('compra');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-gray-50 font-sans text-gray-800 pb-20" data-id="element-0">
      <CountdownTimer data-id="element-1" />
      <SocialProofPopup data-id="element-2" />

      {/* Main Content Container - Padded for fixed header */}
      <div className="pt-16" data-id="element-3">
        {/* Hero Section */}
        <header className="bg-white pb-8 md:pb-12" data-id="element-4">
          <div className="container mx-auto px-4 max-w-4xl" data-id="element-5">
            <div className="text-center py-8 md:py-12 space-y-6" data-id="element-6">
              <h1 className="text-3xl md:text-5xl font-extrabold text-gray-900 leading-tight" data-id="element-7">
                ¿Te sientes inflamada, hinchada y con el abdomen duro aunque
                comas <span className="text-green-600" data-id="element-8">"normal"</span>?
              </h1>
              <p className="text-xl md:text-2xl text-gray-600 font-medium max-w-2xl mx-auto" data-id="element-9">
                Descubre el plan simple que ayuda a tu cuerpo a desinflamarse en
                7 días sin dietas extremas, sin pasar hambre y sin cambiar toda
                tu vida.
              </p>

              <div className="flex justify-center py-6" data-id="element-10">
                <button onClick={scrollToPurchase} className="bg-green-500 hover:bg-green-600 text-white text-xl md:text-2xl font-bold py-4 px-8 rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all flex items-center gap-2 animate-bounce-slow" data-id="element-11">
                  👉 QUIERO DESINFLAMARME
                </button>
              </div>

              <div className="relative mx-auto max-w-md md:max-w-lg cursor-pointer hover:scale-105 transition-transform duration-300" onClick={scrollToPurchase} data-id="element-12">
                <img src={IMAGES.main} alt="Desinflamada en 7 Días Libro Digital" className="w-full h-auto drop-shadow-2xl rounded-lg" data-id="element-13" />
              </div>
            </div>
          </div>
        </header>

        {/* Sales Letter Body */}
        <main className="container mx-auto px-4 max-w-3xl py-12" data-id="element-14">
          <div className="prose prose-lg md:prose-xl mx-auto text-gray-700 space-y-8" data-id="element-15">
            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-16">
              <p className="font-medium" data-id="element-17">
                Te levantas con la panza inflamada. La ropa aprieta más de lo
                normal. Después de comer te sientes pesada. Tu abdomen se
                endurece. Y aunque intentas "comer sano", no mejora.
              </p>
              <p data-id="element-18">No es que comas mal. No es falta de fuerza de voluntad.</p>
              <p className="text-xl font-bold text-red-600" data-id="element-19">
                Es inflamación acumulada.
              </p>
            </div>

            <p data-id="element-20">
              Cuando el cuerpo retiene inflamación todo el tiempo, pasan cosas
              que nadie te explica:
            </p>

            <ul className="space-y-3 list-none pl-0" data-id="element-21">
              {['Te sientes más pesada aunque no hayas subido de peso.', 'La digestión se vuelve lenta.', 'La energía baja.', 'La ropa deja de quedar igual.', 'Y tu abdomen se siente incómodo casi todo el día.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-22">
                  <span className="text-red-500 mt-1" data-id="element-23">❌</span>
                  <span data-id="element-24">{item}</span>
                </li>)}
            </ul>

            <div className="bg-green-50 p-6 rounded-xl border-l-4 border-green-500 my-8" data-id="element-25">
              <p className="text-xl font-bold text-green-800 m-0" data-id="element-26">
                Tu cuerpo no está "fallando". Está inflamado.
              </p>
            </div>

            <p data-id="element-27">
              Por eso creamos{' '}
              <span className="font-bold text-green-600" data-id="element-28">
                Desinflamada en 7 Días™
              </span>
              .
            </p>
            <p data-id="element-29">
              Un plan simple que ayuda a tu cuerpo a dejar de retener
              inflamación innecesaria y recuperar ligereza en pocos días.
            </p>
            <p data-id="element-30">
              No es una dieta estricta. No es un plan extremo. Es una estrategia
              práctica para desinflamar.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 pt-4" data-id="element-31">
              Con este ebook recibes:
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-32">
              {['Un plan guiado de 7 días', 'Menús simples y fáciles', 'Alimentos que ayudan a desinflamar', 'Alimentos que te hinchan sin que lo notes', 'Bebidas desinflamantes rápidas', 'Hábitos diarios que reducen la hinchazón', 'Rutinas simples que ayudan a la digestión'].map((item, i) => <div key={i} className="flex items-center gap-2 bg-white p-3 rounded-lg shadow-sm" data-id="element-33">
                  <Check className="text-green-500 shrink-0" data-id="element-34" />
                  <span className="font-medium text-sm md:text-base" data-id="element-35">
                    {item}
                  </span>
                </div>)}
            </div>

            <div className="flex justify-center py-8" data-id="element-36">
              <button onClick={scrollToPurchase} className="bg-green-500 hover:bg-green-600 text-white text-lg md:text-xl font-bold py-3 px-8 rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all" data-id="element-37">
                👉 QUIERO EMPEZAR AHORA
              </button>
            </div>

            {/* Bonuses Section */}
            <div className="py-12" data-id="element-38">
              <div className="text-center mb-8" data-id="element-39">
                <span className="bg-yellow-400 text-yellow-900 font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wider" data-id="element-40">
                  Gratis por hoy solamente
                </span>
                <h2 className="text-3xl font-bold text-gray-900 mt-4" data-id="element-41">
                  Además, recibes estos bonos de regalo:
                </h2>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-42">
                {[{
                img: IMAGES.bono1,
                title: 'Lista clara de alimentos que desinflaman y los que te hinchan sin saberlo'
              }, {
                img: IMAGES.bono2,
                title: 'Bebidas desinflamantes de emergencia para cuando te sientes pesada'
              }, {
                img: IMAGES.bono3,
                title: 'Rutina de 5 minutos que ayuda a deshinchar el abdomen'
              }, {
                img: IMAGES.bono4,
                title: 'Guía para comer fuera de casa sin volver a inflamarte'
              }].map((bonus, i) => <div key={i} className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow cursor-pointer" onClick={scrollToPurchase} data-id="element-43">
                    <img src={bonus.img} alt={`Bono ${i + 1}`} className="w-full h-auto" data-id="element-44" />
                    <div className="p-4" data-id="element-45">
                      <div className="text-green-600 font-bold text-sm mb-1" data-id="element-46">
                        BONO #{i + 1}
                      </div>
                      <h4 className="font-bold text-gray-800 leading-tight" data-id="element-47">
                        {bonus.title}
                      </h4>
                    </div>
                  </div>)}
              </div>
            </div>

            <p className="text-center font-medium text-xl" data-id="element-48">
              Todo pensado para la vida real.
            </p>

            {/* Benefits Section */}
            <div className="bg-blue-50 p-8 rounded-2xl my-8" data-id="element-49">
              <h3 className="text-2xl font-bold text-center mb-6" data-id="element-50">
                En pocos días puedes empezar a notar:
              </h3>
              <div className="space-y-4" data-id="element-51">
                {['Abdomen menos inflamado', 'Sensación de ligereza', 'Menos pesadez después de comer', 'Digestión más cómoda', 'Más comodidad con tu cuerpo'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-52">
                    <div className="bg-blue-100 p-1 rounded-full" data-id="element-53">
                      <Check className="w-5 h-5 text-blue-600" data-id="element-54" />
                    </div>
                    <span className="font-medium text-lg" data-id="element-55">{item}</span>
                  </div>)}
              </div>
            </div>

            <p className="text-center text-lg italic text-gray-600" data-id="element-56">
              No se trata de adelgazar. Se trata de desinflamar para volver a
              sentirte bien.
            </p>

            {/* Objection Handling */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 my-8" data-id="element-57">
              {[{
              q: '"No tengo tiempo"',
              a: 'el plan es simple'
            }, {
              q: '"No sé cocinar"',
              a: 'todo es fácil'
            }, {
              q: '"Probé dietas y nada"',
              a: 'esto no es dieta, es desinflamar'
            }, {
              q: '"No quiero pasar hambre"',
              a: 'no es restrictivo'
            }].map((item, i) => <div key={i} className="bg-white p-4 rounded-lg shadow-sm border-l-4 border-yellow-400" data-id="element-58">
                  <div className="font-bold text-gray-900" data-id="element-59">{item.q}</div>
                  <div className="text-gray-600" data-id="element-60">→ {item.a}</div>
                </div>)}
            </div>

            <p className="font-medium" data-id="element-61">
              Esto está diseñado para mujeres reales, ocupadas, que necesitan
              algo práctico.
            </p>
            <p className="font-bold text-xl text-center" data-id="element-62">
              Tu cuerpo te está pidiendo ayuda. No esperes a sentirte peor para
              hacer algo.
            </p>
          </div>
        </main>

        {/* Testimonials Section */}
        <section className="bg-gray-100 py-16" data-id="element-63">
          <div className="container mx-auto px-4 max-w-4xl" data-id="element-64">
            <h2 className="text-3xl font-bold text-center mb-12" data-id="element-65">
              Historias de mujeres como tú
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-66">
              {[{
              name: 'Carolina M.',
              loc: 'Bogotá, 34 años',
              text: 'Increíble cómo cambió mi digestión en solo 3 días. Ya no me siento como un globo después de almorzar.'
            }, {
              name: 'Sofía R.',
              loc: 'Buenos Aires, 29 años',
              text: 'Pensé que era normal vivir hinchada. Este plan me enseñó que no. La rutina de 5 minutos es mi salvación.'
            }, {
              name: 'Valentina G.',
              loc: 'Santiago, 41 años',
              text: 'Lo mejor es que no paso hambre. Las recetas son ricas y mi ropa ya no me aprieta en la cintura.'
            }, {
              name: 'Lucía P.',
              loc: 'Lima, 38 años',
              text: 'Llevaba años probando dietas. Esto fue diferente porque me enfoqué en desinflamar, no en la balanza. Me siento liviana.'
            }, {
              name: 'María José',
              loc: 'CDMX, 45 años',
              text: 'Los jugos de emergencia son mágicos. Me siento con mucha más energía y mi abdomen está mucho más plano.'
            }].map((t, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-md" data-id="element-67">
                  <div className="flex text-yellow-400 mb-3" data-id="element-68">
                    {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-4 h-4 fill-current" data-id="element-69" />)}
                  </div>
                  <p className="text-gray-600 mb-4 italic" data-id="element-70">"{t.text}"</p>
                  <div className="flex items-center gap-3" data-id="element-71">
                    <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center text-green-700 font-bold" data-id="element-72">
                      {t.name.charAt(0)}
                    </div>
                    <div data-id="element-73">
                      <div className="font-bold text-sm" data-id="element-74">{t.name}</div>
                      <div className="text-xs text-gray-500" data-id="element-75">{t.loc}</div>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* Purchase Section */}
        <section id="compra" className="py-16 bg-gradient-to-b from-white to-green-50" data-id="element-76">
          <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-77">
            <div className="bg-white p-8 md:p-12 rounded-3xl shadow-2xl border-2 border-green-500 relative overflow-hidden" data-id="element-78">
              <div className="absolute top-0 right-0 bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-79">
                OFERTA LIMITADA
              </div>

              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2" data-id="element-80">
                Acceso Completo + 4 Bonos
              </h2>
              <p className="text-gray-500 mb-8" data-id="element-81">
                Empieza tu transformación hoy mismo
              </p>

              <div className="flex justify-center items-baseline gap-2 mb-8" data-id="element-82">
                <span className="text-gray-400 line-through text-2xl" data-id="element-83">
                  $47.00
                </span>
                <span className="text-5xl md:text-6xl font-extrabold text-green-600" data-id="element-84">
                  $13.99
                </span>
                <span className="text-gray-500 font-medium" data-id="element-85">USD</span>
              </div>

              <a href={CHECKOUT_URL} className="block w-full bg-green-500 hover:bg-green-600 text-white text-xl md:text-2xl font-bold py-5 px-8 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all animate-pulse-slow mb-6" data-id="element-86">
                👉 QUIERO DESINFLAMARME AHORA
              </a>

              <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-sm text-gray-500 mb-8" data-id="element-87">
                <div className="flex items-center gap-1" data-id="element-88">
                  <Lock className="w-4 h-4" data-id="element-89" /> Pago 100% Seguro
                </div>
                <div className="flex items-center gap-1" data-id="element-90">
                  <ShieldCheck className="w-4 h-4" data-id="element-91" /> Garantía de 7 Días
                </div>
                <div className="flex items-center gap-1" data-id="element-92">
                  <CreditCard className="w-4 h-4" data-id="element-93" /> Acceso Inmediato
                </div>
              </div>

              <div className="border-t border-gray-100 pt-6" data-id="element-94">
                <p className="text-sm text-gray-500" data-id="element-95">
                  Acceso inmediato. Contenido digital. Puedes empezar hoy mismo.
                </p>
                <div className="flex justify-center gap-2 mt-4 opacity-60 grayscale hover:grayscale-0 transition-all" data-id="element-96">
                  <img src="https://cdn.magicpatterns.com/uploads/1stx75SQGPjFurESQtiD6H/payment-icons.png" alt="Métodos de pago" className="h-6 object-contain" onError={e => e.currentTarget.style.display = 'none'} data-id="element-97" />
                  <span className="text-xs" data-id="element-98">
                    Visa • Mastercard • PayPal • Amex
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-16 bg-white" data-id="element-99">
          <div className="container mx-auto px-4" data-id="element-100">
            <h2 className="text-3xl font-bold text-center mb-10" data-id="element-101">
              Preguntas Frecuentes
            </h2>
            <FAQAccordion data-id="element-102" />
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-gray-900 text-gray-400 py-12 text-center text-sm" data-id="element-103">
          <div className="container mx-auto px-4" data-id="element-104">
            <p className="mb-4" data-id="element-105">
              © 2024 Desinflamada en 7 Días™. Todos los derechos reservados.
            </p>
            <p className="max-w-2xl mx-auto text-xs text-gray-600" data-id="element-106">
              Este producto no sustituye el parecer de un médico profesional.
              Consulta siempre a un médico para tratar los asuntos relacionados
              con tu salud. Los resultados pueden variar de persona a persona.
            </p>
          </div>
        </footer>
      </div>
    </div>;
}